import React from 'react';
import { View } from 'react-native';

import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';
import PropTypes from 'prop-types';

import Row from '../Row/Row';
import Separator from '../Separator/Separator';

import style from './style';

const Body = ({ feeTitle, feeValue, numOfInstalmentValue, numOfInstalmentTitle }) => {
  const theme = useTheme();
  return (
    <View style={style.container}>
      <Row
        title={feeTitle}
        value={feeValue}
        valueStyle={style.textStyle(theme)}
        titleStyle={style.textStyle(theme)}
      />
      <Row
        title={numOfInstalmentTitle}
        value={numOfInstalmentValue}
        rowStyle={style.rowStyle}
        valueStyle={style.textStyle(theme)}
        titleStyle={style.textStyle(theme)}
      />
      <Separator />
    </View>
  );
};

Body.propTypes = {
  feeTitle: PropTypes.string,
  feeValue: PropTypes.string,
  numOfInstalmentValue: PropTypes.string,
  numOfInstalmentTitle: PropTypes.string,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};

export default Body;
